<div class="cv-resubmit-component" *ngIf="isResubmit">
	<div class="cv-resubmit-box" *ngIf="isImported">
		<div class="modal-header">
			<h5 class="modal-title">Order recall</h5>
			<button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="toggleReSubmitBox()">
				<i class="fa-regular fa-xmark"></i>
			</button>
		</div>
		<div class="modal-body">
			<p>
				This order was imported from <strong>'{{ dataOrder.externalProvider }}'</strong>.
				Do you want to recall it?
			</p>
			<p>(This process could take from 30s to 1 minute to complete)</p>
			<div class="filter filter-select">
				<div class="multiselect-filter__container">
					<label class="select-lbl">Reason Types:</label>
					<cv-dropdown
						[required]="true"
						[options]="reasonTypes"
						(valuesChange)="onReasonCategoryChange($event)"
						[optionText]="'label'"
						[optionValue]="'key'"
						[placeholder]="'Please choose a reason'"
					>
					</cv-dropdown>
				</div>
			</div>
			<div class="filter">
				<div class="input-filter__container">
					<label class="text-lbl">Reason:</label>
					<cv-input
						[required]="true"
						(controlKeyup)="onReasonChange($event)"
						[type]="'textarea'"
						[name]="'reason'"
						[placeholder]="'Please enter a reason'"
					></cv-input>
				</div>
			</div>
		</div>

		<div class="modal-footer">
			<button pButton type="button" [disabled]="isReasonFormInvalid()" class="confirm-btn p-button-primary p-button-outlined p-button-sm"
				(click)="reSubmitImported()">Confirm</button>
			<button pButton type="button" class="close-btn p-button-secondary p-button-outlined p-button-sm"
				data-dismiss="modal" (click)="toggleReSubmitBox()">Close</button>
		</div>
	</div>
	<div class="cv-resubmit-box cv-resubmit-created-Order" *ngIf="!isImported">
		<div class="modal-header">
			<h5 class="modal-title">Order recall</h5>
			<button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="toggleReSubmitBox()">
				<i class="fa-regular fa-xmark"></i>
			</button>
		</div>
		<div class="modal-body">
			<div class="file-upload-container">
				<label class="xml-file-title">{{ uploadLabelText  }}</label>
				<label class="xml-file-notification">this is required to reacall QC Order</label>
				<cv-drag-and-drop-file [message]="filesDropMessage" (filesDropped)="onFilesDropped($event)"
					[ngClass]="fileDropped ? 'fileDroped':''"></cv-drag-and-drop-file>
				<div *ngIf="mismoFileErrorMessage" class="file-error-message">
					{{ mismoFileErrorMessage }}
				</div>
			</div>
			<cv-engagement-file-upload 
				(fileSelected)="onEngagementFileSelect($event)"
				(fileRemoved)="removeEngagementFile()">
			</cv-engagement-file-upload>
		</div>
		<div class="modal-footer">
			<button 
				pButton 
				type="button" 
				class="confirm-btn p-button-primary p-button-outlined p-button-sm"
				[disabled]="
					!resubmitManuallyCreatedOrder.orderId || 
					!resubmitManuallyCreatedOrder.file || 
					mismoFileErrorMessage || 
					!isEngagementFileValid"
				(click)="reSubmitCreated()">Confirm</button>
			<button 
				pButton 
				type="button"
				label="Close" 
				class="close-btn p-button-secondary p-button-outlined p-button-sm"
				data-dismiss="modal" 
				(click)="toggleReSubmitBox()">
			</button>
		</div>
	</div>
</div>